import { IGetSavedCvsRequest } from 'data-transfers/requests'

export const savedCvKeys = {
  all: ['saved-cv'] as const,
  savedCvs: (payload: IGetSavedCvsRequest) => [...savedCvKeys.all, payload]
}
